module.exports = __webpack_public_path__ + "img/moins_3.3d3e32be.svg";